<template>
  <div class="login-container">
    <form class="login-card" @submit.prevent="onSubmit">
      <h1 class="login-title">Reset your password</h1>

      <p class="login-hint">
        Enter your email and we’ll send you a reset link.
      </p>

      <label class="login-label">Email</label>
      <input
        v-model.trim="email"
        type="email"
        required
        class="login-input"
        placeholder="you@company.com"
        autocomplete="email"
      />

      <p v-if="error" class="login-error">{{ error }}</p>
      <p v-if="message" class="login-success">{{ message }}</p>

      <button :disabled="loading" class="login-button">
        <span v-if="!loading">Send reset link</span>
        <span v-else>Sending…</span>
      </button>

      <p class="back-link">
        <router-link to="/login">Back to login</router-link>
      </p>
    </form>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ForgotPassword',
  data() {
    return {
      email: '',
      loading: false,
      error: null,
      message: null,
    }
  },
  methods: {
    async onSubmit() {
      this.error = null
      this.message = null

      if (!this.email) {
        this.error = 'Email is required.'
        return
      }

      this.loading = true

      try {
        const { data } = await axios.post('/auth/forgot-password', {
          email: this.email,
        })

        this.message = data?.message || 'If that email exists, a password reset link has been sent.'
      } catch (e) {
        this.error = e?.response?.data?.error || e?.message || 'Unable to send reset link.'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0b0101;
  padding: 24px;
  box-sizing: border-box;
}

.login-card {
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-sizing: border-box;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  text-align: left;
  font-family: Garamond, serif;
  color: #2c3e50;
}

.login-title {
  margin: 0 0 16px 0;
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
}

.login-label {
  display: block;
  font-size: 14px;
  margin: 10px 0 6px 0;
}

.login-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 16px;
  outline: none;
  box-sizing: border-box;
}

.login-input:focus {
  border-color: #2c3e50;
}

.login-error {
  color: #b00020;
  font-size: 14px;
  margin-top: 10px;
}

.login-success {
  color: #166534;
  font-size: 14px;
  margin-top: 10px;
}

.login-button {
  width: 100%;
  margin-top: 16px;
  padding: 10px 12px;
  border: none;
  border-radius: 10px;
  background: #000000;
  color: #ffffff;
  font-size: 16px;
  cursor: pointer;
}

.login-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-hint {
  font-size: 13px;
  color: #4b5563;
  margin-top: 0;
}

.back-link {
  text-align: center;
  font-size: 13px;
  margin-top: 14px;
}

.back-link a {
  color: #2c3e50;
  text-decoration: underline;
}
</style>